<!-- Default Footer -->
<footer
    class="footer-area"
    [style.backgroundColor]="settings.style.footer.bgColor ? settings.style.footer.bgColor : '#000000'"
    [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'"
    *ngIf="showFooter()"
>
    <div class="container">
        <div class="row justify-content-center getStartedSection" *ngIf="settings.style.footer.getStarted.show ?? false">
            <div class="col-lg-8 col-12">
                <p class="getStartedText" [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'">{{ settings.style.footer.getStarted.text }}</p>
            </div>
            <div class="col-lg-4 col-12 getStartedButtonWrapper">
                <a [routerLink]="settings.style.footer.getStarted.url" class="btn btn-primary getStartedButton">
                    {{ settings.style.footer.getStarted.buttonText }}
                </a>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-{{cssCols}} col-12">
                <div class="single-footer-widget">
                    <div
                        class="logo"
                        [ngClass]="{'d-none': true}"
                    >
                        <a href="{{getLogoLinkUrl()}}" [target]="getLinkTarget('website')">
                            <img src="{{getLinkUrlById('smallLogo')}}" alt="logo">
                        </a>
                    </div>
                    <div
                        class="logo d-none"
                        [ngClass]="{'d-inline-block': true}"
                    >
                        <a href="{{getLogoLinkUrl()}}" [target]="getLinkTarget('website')">
                            <img src="{{getLinkUrlById('bigLogoWhite')}}" alt="white-logo" class="footer-logo">
                        </a>
                    </div>
                    <p>{{settings.description}}</p>
                    <ul class="social-links">
                        <li *ngIf="getLinkUrlById('instagram') != ''">
                            <a href="{{getLinkUrlById('instagram')}}" [target]="getLinkTarget('instagram')">
                                <i class="fa-brands fa-instagram"></i>
                            </a>
                        </li>
                        <li *ngIf="getLinkUrlById('facebook') != ''">
                            <a href="{{getLinkUrlById('facebook')}}" [target]="getLinkTarget('facebook')">
                                <i class="fa-brands fa-facebook-f"></i>
                            </a>
                        </li>
                        <li *ngIf="getLinkUrlById('twitter') != ''">
                            <a href="{{getLinkUrlById('twitter')}}" [target]="getLinkTarget('twitter')">
                                <i class="fa-brands fa-twitter"></i>
                            </a>
                        </li>
                        <li *ngIf="getLinkUrlById('tiktok') != ''">
                            <a href="{{getLinkUrlById('tiktok')}}" [target]="getLinkTarget('tiktok')">
                                <i class="fa-brands fa-tiktok"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-{{cssCols}} col-6" *ngIf="companyLinks.length > 0">
                <div class="single-footer-widget">
                    <h3 [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'">Company</h3>
                    <ul class="list">
                        <ng-container *ngFor="let link of companyLinks">
                            <li *ngIf="link.url">
                                <a [href]="link.url" [attr.target]="getLinkTargetForLink(link)"
                                [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'"
                                >{{ link.name }}</a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-lg-{{cssCols}} col-6" *ngIf="legalLinks.length > 0">
                <div class="single-footer-widget">
                    <h3 [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'">Legal</h3>
                    <ul class="list">
                        <ng-container *ngFor="let link of legalLinks">
                            <li *ngIf="link.url">
                                <a [href]="link.url" [attr.target]="getLinkTargetForLink(link)"
                                [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'"
                                >{{ link.name }}</a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-lg-{{cssCols}} col-6" *ngIf="helpLinks.length > 0">
                <div class="single-footer-widget">
                    <h3 [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'">Help</h3>
                    <ul class="list">
                        <ng-container *ngFor="let link of helpLinks">
                            <li *ngIf="link.url">
                                <a [href]="link.url" [attr.target]="getLinkTargetForLink(link)"
                                [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'"
                                >{{ link.name }}</a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                
                <small class="footer-badge" [style.color]="settings.style.footer.textColor ? settings.style.footer.textColor : '#FFFFFF'">This site is protected by reCAPTCHA and the Google 
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                </small>
            </div>
        </div>
    </div>
    <div class="copyright-area">
        <div class="container">
            <p>© {{currentYear()}} {{settings.name}}</p>
        </div>
    </div>
</footer>
